import { httpStatus as types } from '../mutation-types';

export default {
    namespaced: true,
    state: {
        statusCode: 200,
        isShow: false,
        statusData: [
            {
                code: 404,
                url: '',
                msg: '目前找不到這個API，請利用導覽列進行其他頁面瀏覽。',
                callback: null,
            },
            // serverError
            {
                code: 500,
                url: '',
                msg: '判讀有誤，請再調整或置換圖片。',
                callback: null,
            },
        ],
    },
    // getters,
    actions: {
        setStatusCode({ commit }, val) {
            commit(types.setStatusCode, val);
        },
        setIsShow({ commit }, val) {
            commit(types.setIsShow, val);
        },
        setStatusData({ commit }, val) {
            commit(types.setStatusData, val);
        },
    },
    mutations: {
        [types.setStatusCode]: (state, data) => {
            state.statusCode = data;
        },
        [types.setIsShow]: (state, data) => {
            state.isShow = data;
        },
        [types.setStatusData]: (state, data) => {
            state.statusData = data;
        },
    },
};
